// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* New Appointment form only. Namespaced so Calendar / Chart / Encounters stay unchanged. */

.emr-aptform,
.emr-aptform *,
.emr-aptform *::before,
.emr-aptform *::after,
.emr-aptform-select,
.emr-aptform-select *,
.emr-aptform-select *::before,
.emr-aptform-select *::after {
  border-radius: 0 !important;
}

.emr-aptform {
  --emr-aptform-primary: #1976d2;
  --emr-aptform-primary-dark: #0d47a1;
  --emr-aptform-text: #212121;
  --emr-aptform-muted: #616161;
  --emr-aptform-border: #e0e0e0;
  --emr-aptform-surface: #ffffff;
  --emr-aptform-label: 152px;
  --emr-aptform-label-gap: 12px;
  max-width: 1400px;
  margin: 0 auto;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  color: var(--emr-aptform-text);
  overflow-x: hidden;
}

.emr-aptform__pagehead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  min-width: 0;
}

.emr-mz-dashboard .emr-aptform__title,
.emr-aptform__title {
  margin: 0;
  font-size: 20px !important;
  font-weight: 600;
  line-height: 1.25;
  color: var(--emr-aptform-text);
}

.emr-aptform__subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  font-weight: 400;
  color: var(--emr-aptform-muted);
}

.emr-aptform__head-actions {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 8px;
}

.emr-mz-dashboard .btn.emr-aptform__cancel,
.emr-aptform__cancel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 14px;
  margin: 0;
  background: #fff !important;
  color: var(--emr-aptform-primary) !important;
  border: 1px solid var(--emr-aptform-primary);
  box-shadow: none;
}

.emr-mz-dashboard .btn.emr-aptform__cancel:hover,
.emr-mz-dashboard .btn.emr-aptform__cancel:focus,
.emr-aptform__cancel:hover,
.emr-aptform__cancel:focus {
  background: #e3f2fd !important;
  color: var(--emr-aptform-primary-dark) !important;
}

.emr-mz-dashboard .btn.emr-aptform__save,
.emr-aptform__save {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  margin: 0;
  background: var(--emr-aptform-primary) !important;
  color: #fff !important;
  border: 1px solid var(--emr-aptform-primary);
  box-shadow: none;
}

.emr-mz-dashboard .btn.emr-aptform__save:hover,
.emr-mz-dashboard .btn.emr-aptform__save:focus,
.emr-aptform__save:hover,
.emr-aptform__save:focus {
  background: var(--emr-aptform-primary-dark) !important;
  border-color: var(--emr-aptform-primary-dark);
}

.emr-mz-dashboard .btn.emr-aptform__save:disabled,
.emr-aptform__save:disabled,
.emr-mz-dashboard .btn.emr-aptform__secondary:disabled,
.emr-aptform__secondary:disabled {
  opacity: 0.55;
  pointer-events: none;
}

.emr-mz-dashboard .btn.emr-aptform__secondary,
.emr-aptform__secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  margin: 0;
  background: #fff !important;
  color: var(--emr-aptform-primary) !important;
  border: 1px solid var(--emr-aptform-border);
  box-shadow: none;
}

.emr-mz-dashboard .btn.emr-aptform__secondary:hover,
.emr-aptform__secondary:hover {
  border-color: var(--emr-aptform-primary);
  background: #e3f2fd !important;
}

.emr-aptform__icon {
  width: 14px;
  height: 14px;
}

.emr-aptform__req {
  color: #d32f2f;
}

.emr-aptform__section {
  margin: 0 0 8px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  background: var(--emr-aptform-surface);
  border: 1px solid var(--emr-aptform-border);
  box-shadow: none;
  padding: 8px 12px 10px;
}

.emr-aptform__section-title {
  margin: 0 0 6px;
  font-size: 11px !important;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--emr-aptform-muted);
}

.emr-aptform__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  column-gap: var(--emr-aptform-label-gap);
  row-gap: 2px;
  align-items: center;
  min-width: 0;
  padding: 3px 0;
}

.emr-aptform__label {
  font-size: 13px;
  font-weight: 600;
  color: var(--emr-aptform-text);
  line-height: 1.3;
  padding-top: 0;
  min-width: 0;
}

.emr-mz-dashboard .emr-aptform label.emr-aptform__label,
.emr-aptform label.emr-aptform__label {
  display: block;
  margin: 0;
  left: auto;
  transform: none;
  height: auto;
  position: static;
}

.emr-aptform__control {
  min-width: 0;
  width: 100%;
  max-width: 100%;
}

.emr-aptform__cluster {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

@media only screen and (min-width: 601px) {
  .emr-aptform__row {
    grid-template-columns: var(--emr-aptform-label) minmax(0, 1fr);
    align-items: center;
  }

  .emr-aptform__row--start {
    align-items: start;
  }

  .emr-aptform__row--start .emr-aptform__label {
    padding-top: 8px;
  }

  .emr-mz-dashboard .emr-aptform label.emr-aptform__label,
  .emr-aptform label.emr-aptform__label,
  .emr-aptform__label {
    width: 100% !important;
    max-width: none;
    box-sizing: border-box;
  }

  .emr-aptform__indent {
    margin-left: calc(var(--emr-aptform-label) + var(--emr-aptform-label-gap));
    padding-left: 0;
  }
}

@media only screen and (min-width: 900px) {
  .emr-aptform__cluster--split,
  .emr-aptform__cluster--when {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 24px;
    align-items: start;
  }

  .emr-aptform__cluster--split .emr-aptform__row,
  .emr-aptform__cluster--when .emr-aptform__row {
    width: 100%;
    min-width: 0;
  }
}

.emr-mz-dashboard .emr-aptform input.emr-aptform__input,
.emr-aptform input.emr-aptform__input,
.emr-mz-dashboard .emr-aptform textarea.emr-aptform__input,
.emr-aptform textarea.emr-aptform__input {
  height: 36px !important;
  min-height: 36px !important;
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  margin: 0 !important;
  box-sizing: border-box !important;
  padding: 0 10px !important;
  border: 1px solid var(--emr-aptform-border) !important;
  border-radius: 0 !important;
  background: var(--emr-aptform-surface) !important;
  box-shadow: none !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  color: var(--emr-aptform-text) !important;
  line-height: 34px !important;
}

.emr-mz-dashboard .emr-aptform textarea.emr-aptform__input,
.emr-aptform textarea.emr-aptform__input {
  height: auto !important;
  min-height: 72px !important;
  padding: 8px 10px !important;
  line-height: 1.4 !important;
  resize: vertical;
}

.emr-mz-dashboard .emr-aptform input.emr-aptform__input:focus,
.emr-mz-dashboard .emr-aptform textarea.emr-aptform__input:focus,
.emr-aptform input.emr-aptform__input:focus,
.emr-aptform textarea.emr-aptform__input:focus {
  border: 1px solid var(--emr-aptform-primary) !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18) !important;
  outline: none;
}

.emr-mz-dashboard .emr-aptform input[type="date"],
.emr-aptform input[type="date"] {
  min-width: 0 !important;
  max-width: 100%;
}

.emr-aptform__search {
  position: relative;
  min-width: 0;
}

.emr-aptform__search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  width: 14px;
  height: 14px;
  transform: translateY(-50%);
  color: var(--emr-aptform-muted);
  pointer-events: none;
  z-index: 1;
}

.emr-mz-dashboard .emr-aptform input.emr-aptform__search-input,
.emr-aptform input.emr-aptform__search-input {
  padding-left: 32px !important;
}

.emr-aptform__results {
  position: absolute;
  z-index: 30;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  max-height: 240px;
  overflow-x: hidden;
  overflow-y: auto;
  background: #fff;
  border: 1px solid var(--emr-aptform-border);
  box-shadow: none;
}

.emr-aptform__result {
  display: flex;
  width: 100%;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  padding: 6px 10px;
  text-align: left;
  background: #fff;
  border: 0;
  cursor: pointer;
}

.emr-aptform__result:hover,
.emr-aptform__result:focus {
  background: #e3f2fd;
}

.emr-aptform__result-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--emr-aptform-text);
}

.emr-aptform__result-meta,
.emr-aptform__results-empty,
.emr-aptform__hint {
  font-size: 12px;
  color: var(--emr-aptform-muted);
}

.emr-aptform__results-empty {
  padding: 8px 10px;
}

.emr-aptform__hint {
  padding: 2px 0 4px;
}

.emr-aptform__patient {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
  padding: 8px 10px;
  background: #fafbfc;
  border: 1px solid var(--emr-aptform-border);
}

.emr-aptform__avatar {
  display: flex;
  height: 32px;
  width: 32px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: #e3f2fd;
  color: var(--emr-aptform-primary);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.emr-aptform__patient-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--emr-aptform-text);
}

.emr-aptform__mrn {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 7px;
  background: #0b1f33;
  color: #90caf9;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.emr-aptform__patient-meta {
  font-size: 12px;
  color: var(--emr-aptform-muted);
}

.emr-aptform a.emr-aptform__chart-link,
.emr-aptform__chart-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: var(--emr-aptform-primary) !important;
  text-decoration: none;
}

.emr-aptform__chart-link:hover {
  text-decoration: underline;
}

.emr-aptform__noshow {
  font-size: 12px;
  font-weight: 600;
  color: #ef6c00;
}

.emr-aptform__date,
.emr-aptform__time,
.emr-aptform__select--sm {
  width: 100%;
  max-width: 100%;
}

.emr-aptform__end {
  font-size: 13px;
  font-weight: 600;
  color: var(--emr-aptform-text);
}

.emr-mz-dashboard .emr-aptform__select,
.emr-aptform__select {
  height: 36px !important;
  min-height: 36px !important;
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box !important;
  border: 1px solid var(--emr-aptform-border) !important;
  border-radius: 0 !important;
  background: var(--emr-aptform-surface) !important;
  box-shadow: none !important;
  font-size: 13px !important;
  font-weight: 400 !important;
}

.emr-mz-dashboard .emr-aptform__select:focus,
.emr-aptform__select:focus {
  border: 1px solid var(--emr-aptform-primary) !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18) !important;
  outline: none;
}

.emr-aptform-select {
  border-radius: 0 !important;
  border: 1px solid var(--emr-aptform-border, #e0e0e0) !important;
  background: #fff !important;
  box-shadow: none !important;
  z-index: 200;
}

.emr-aptform__radios {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
}

.emr-aptform__radio {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.emr-aptform [role="radio"] {
  width: 14px !important;
  height: 14px !important;
  min-width: 14px;
  border: 1px solid #90a4ae !important;
  background: #fff !important;
  box-shadow: none !important;
  border-radius: 50% !important;
}

.emr-aptform [role="radio"][data-state="checked"] {
  border-color: var(--emr-aptform-primary) !important;
  color: var(--emr-aptform-primary) !important;
}

.emr-aptform [role="radio"] svg {
  width: 8px !important;
  height: 8px !important;
  fill: var(--emr-aptform-primary) !important;
  border-radius: 50% !important;
}

.emr-aptform__radio-label {
  cursor: pointer;
  font-size: 13px;
  font-weight: 400 !important;
  color: var(--emr-aptform-text);
  line-height: 1.2;
}

.emr-aptform__referring {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 8px;
  background: #fafbfc;
  border: 1px solid var(--emr-aptform-border);
}

.emr-aptform__referring-name {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--emr-aptform-text);
}

.emr-aptform__referring-org {
  margin: 1px 0 0;
  font-size: 12px;
  color: var(--emr-aptform-muted);
}

.emr-aptform__clear {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--emr-aptform-muted);
  cursor: pointer;
}

.emr-aptform__clear:hover {
  color: var(--emr-aptform-primary-dark);
}

.emr-aptform__count {
  margin-top: 2px;
  text-align: right;
  font-size: 11px;
  color: var(--emr-aptform-muted);
}

.emr-aptform__note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 10px;
  margin: 4px 0;
  background: #e3f2fd;
  border: 1px solid #bbdefb;
  font-size: 12px;
  line-height: 1.4;
  color: #0d47a1;
}

.emr-aptform__note-icon {
  width: 14px;
  height: 14px;
  margin-top: 1px;
  flex-shrink: 0;
}

.emr-aptform__preview-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.emr-aptform__preview-meta {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 12px;
  font-size: 13px;
  color: var(--emr-aptform-text);
}

.emr-aptform__preview-date {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--emr-aptform-muted);
}

.emr-aptform__preview-strong {
  font-weight: 600;
}

.emr-aptform__preview-muted {
  color: var(--emr-aptform-muted);
}

.emr-aptform__chip {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  background: #e8f5e9;
  color: #2e7d32;
  font-size: 11px;
  font-weight: 600;
}

.emr-aptform__preview-actions {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 8px;
}

.emr-aptform__status-msg {
  padding: 28px 16px;
  text-align: center;
  font-size: 13px;
  color: var(--emr-aptform-muted);
}

@media only screen and (min-width: 1024px) {
  .emr-aptform__preview-body {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

@media only screen and (max-width: 899px) {
  .emr-aptform__pagehead {
    flex-wrap: wrap;
  }
}

@media only screen and (max-width: 600px) {
  .emr-aptform__pagehead {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .emr-mz-dashboard .emr-aptform__title,
  .emr-aptform__title {
    font-size: 18px !important;
  }

  .emr-aptform__head-actions,
  .emr-aptform__preview-actions {
    width: 100%;
  }

  .emr-mz-dashboard .btn.emr-aptform__cancel,
  .emr-mz-dashboard .btn.emr-aptform__save,
  .emr-mz-dashboard .btn.emr-aptform__secondary,
  .emr-aptform__cancel,
  .emr-aptform__save,
  .emr-aptform__secondary {
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
  }

  .emr-aptform__date,
  .emr-aptform__time,
  .emr-aptform__select--sm {
    max-width: 100%;
  }

  .emr-aptform__section {
    padding: 8px 10px;
  }
}

/* ------------------------------------------------------------------ */
/* Access-style modular two-column layout.                            */
/* New Appointment uses --new. Edit Appointment uses --edit only.     */
/* ------------------------------------------------------------------ */

.emr-aptform--new,
.emr-aptform--edit {
  --emr-aptform-label: 128px;
  --emr-aptform-label-gap: 10px;
}

.emr-aptform--new .emr-aptform__pagehead,
.emr-aptform--edit .emr-aptform__pagehead {
  margin-bottom: 8px;
}

.emr-aptform--new .emr-aptform__modules,
.emr-aptform--edit .emr-aptform__modules {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.emr-aptform--new .emr-aptform__section,
.emr-aptform--edit .emr-aptform__section {
  margin: 0;
  min-width: 0;
  height: auto;
}

.emr-aptform--new .emr-aptform__module,
.emr-aptform--edit .emr-aptform__module {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

@media only screen and (min-width: 1024px) {
  .emr-aptform--new .emr-aptform__modules,
  .emr-aptform--edit .emr-aptform__modules {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 8px;
    align-items: stretch;
  }

  .emr-aptform--new .emr-aptform__module--wide,
  .emr-aptform--edit .emr-aptform__module--wide {
    grid-column: 1 / -1;
  }

  .emr-aptform--new .emr-aptform__module,
  .emr-aptform--edit .emr-aptform__module {
    height: 100%;
  }

  /* Half-width modules: stack Date/Time pairs so long values stay readable. */
  .emr-aptform--new .emr-aptform__cluster--when,
  .emr-aptform--edit .emr-aptform__cluster--when {
    display: flex;
    flex-direction: column;
    column-gap: 0;
  }

  /* Edit only: stack Where/Who so long location names stay readable. */
  .emr-aptform--edit .emr-aptform__cluster--split {
    display: flex;
    flex-direction: column;
    column-gap: 0;
  }

  .emr-aptform--new textarea.emr-aptform__input,
  .emr-aptform--edit textarea.emr-aptform__input {
    min-height: 56px !important;
  }

  .emr-aptform--new .emr-aptform__note,
  .emr-aptform--edit .emr-aptform__note {
    padding: 6px 8px;
    margin: 2px 0 4px;
  }
}

/* Half-width modules: stack Where/Who pairs below 1440 so labels stay aligned. */
@media only screen and (min-width: 1024px) and (max-width: 1439px) {
  .emr-aptform--new .emr-aptform__cluster--split,
  .emr-aptform--edit .emr-aptform__cluster--split {
    display: flex;
    flex-direction: column;
    column-gap: 0;
  }
}

/* Wide screens: use remaining horizontal space inside Visit and When. */
@media only screen and (min-width: 1440px) {
  .emr-aptform--new .emr-aptform__module--visit,
  .emr-aptform--new .emr-aptform__module--when,
  .emr-aptform--edit .emr-aptform__module--visit,
  .emr-aptform--edit .emr-aptform__module--when {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 16px;
    align-items: start;
  }

  .emr-aptform--new .emr-aptform__module--visit .emr-aptform__section-title,
  .emr-aptform--new .emr-aptform__module--visit > .emr-aptform__row:nth-of-type(1),
  .emr-aptform--new .emr-aptform__module--visit > .emr-aptform__row:nth-of-type(4),
  .emr-aptform--new .emr-aptform__module--when .emr-aptform__section-title,
  .emr-aptform--new .emr-aptform__module--when > .emr-aptform__cluster,
  .emr-aptform--edit .emr-aptform__module--visit .emr-aptform__section-title,
  .emr-aptform--edit .emr-aptform__module--visit > .emr-aptform__row:nth-of-type(1),
  .emr-aptform--edit .emr-aptform__module--visit > .emr-aptform__row:nth-of-type(4),
  .emr-aptform--edit .emr-aptform__module--when .emr-aptform__section-title,
  .emr-aptform--edit .emr-aptform__module--when > .emr-aptform__cluster {
    grid-column: 1 / -1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-appointment-form.css"],"names":[],"mappings":"AAAA,2FAA2F;;AAE3F;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,4CAA4C;EAC5C,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;;;;EAIE,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,iDAAiD;EACjD,sBAAsB;EACtB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;;;;EAIE,sDAAsD;EACtD,6CAA6C;AAC/C;;AAEA;;;;EAIE,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,4CAA4C;EAC5C,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;;EAEE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,2CAA2C;EAC3C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,wCAAwC;EACxC,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,SAAS;EACT,UAAU;EACV,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,YAAY;AACd;;AAEA;EACE;IACE,8DAA8D;IAC9D,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,sBAAsB;IACtB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,0EAA0E;IAC1E,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,aAAa;IACb,oDAAoD;IACpD,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;;;EAIE,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,0BAA0B;EAC1B,sDAAsD;EACtD,2BAA2B;EAC3B,iDAAiD;EACjD,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;;EAIE,uDAAuD;EACvD,yDAAyD;EACzD,aAAa;AACf;;AAEA;;EAEE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,+BAA+B;EAC/B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;;EAGE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,sDAAsD;EACtD,2BAA2B;EAC3B,iDAAiD;EACjD,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,uDAAuD;EACvD,yDAAyD;EACzD,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,+DAA+D;EAC/D,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,mDAAmD;EACnD,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,WAAW;EACb;;EAEA;;;;;;IAME,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;;AAEvE;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,SAAS;EACT,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;;IAEE,aAAa;IACb,oDAAoD;IACpD,QAAQ;IACR,oBAAoB;EACtB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;EACd;;EAEA,4EAA4E;EAC5E;;IAEE,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA,qEAAqE;EACrE;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,iFAAiF;AACjF;EACE;;IAEE,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA,wEAAwE;AACxE;EACE;;;;IAIE,aAAa;IACb,oDAAoD;IACpD,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;;;;;;;;;IAUE,mBAAmB;EACrB;AACF","sourcesContent":["/* New Appointment form only. Namespaced so Calendar / Chart / Encounters stay unchanged. */\n\n.emr-aptform,\n.emr-aptform *,\n.emr-aptform *::before,\n.emr-aptform *::after,\n.emr-aptform-select,\n.emr-aptform-select *,\n.emr-aptform-select *::before,\n.emr-aptform-select *::after {\n  border-radius: 0 !important;\n}\n\n.emr-aptform {\n  --emr-aptform-primary: #1976d2;\n  --emr-aptform-primary-dark: #0d47a1;\n  --emr-aptform-text: #212121;\n  --emr-aptform-muted: #616161;\n  --emr-aptform-border: #e0e0e0;\n  --emr-aptform-surface: #ffffff;\n  --emr-aptform-label: 152px;\n  --emr-aptform-label-gap: 12px;\n  max-width: 1400px;\n  margin: 0 auto;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  color: var(--emr-aptform-text);\n  overflow-x: hidden;\n}\n\n.emr-aptform__pagehead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n  min-width: 0;\n}\n\n.emr-mz-dashboard .emr-aptform__title,\n.emr-aptform__title {\n  margin: 0;\n  font-size: 20px !important;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--emr-aptform-text);\n}\n\n.emr-aptform__subtitle {\n  margin: 2px 0 0;\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--emr-aptform-muted);\n}\n\n.emr-aptform__head-actions {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.emr-mz-dashboard .btn.emr-aptform__cancel,\n.emr-aptform__cancel {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  padding: 0 14px;\n  margin: 0;\n  background: #fff !important;\n  color: var(--emr-aptform-primary) !important;\n  border: 1px solid var(--emr-aptform-primary);\n  box-shadow: none;\n}\n\n.emr-mz-dashboard .btn.emr-aptform__cancel:hover,\n.emr-mz-dashboard .btn.emr-aptform__cancel:focus,\n.emr-aptform__cancel:hover,\n.emr-aptform__cancel:focus {\n  background: #e3f2fd !important;\n  color: var(--emr-aptform-primary-dark) !important;\n}\n\n.emr-mz-dashboard .btn.emr-aptform__save,\n.emr-aptform__save {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  margin: 0;\n  background: var(--emr-aptform-primary) !important;\n  color: #fff !important;\n  border: 1px solid var(--emr-aptform-primary);\n  box-shadow: none;\n}\n\n.emr-mz-dashboard .btn.emr-aptform__save:hover,\n.emr-mz-dashboard .btn.emr-aptform__save:focus,\n.emr-aptform__save:hover,\n.emr-aptform__save:focus {\n  background: var(--emr-aptform-primary-dark) !important;\n  border-color: var(--emr-aptform-primary-dark);\n}\n\n.emr-mz-dashboard .btn.emr-aptform__save:disabled,\n.emr-aptform__save:disabled,\n.emr-mz-dashboard .btn.emr-aptform__secondary:disabled,\n.emr-aptform__secondary:disabled {\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n.emr-mz-dashboard .btn.emr-aptform__secondary,\n.emr-aptform__secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 12px;\n  margin: 0;\n  background: #fff !important;\n  color: var(--emr-aptform-primary) !important;\n  border: 1px solid var(--emr-aptform-border);\n  box-shadow: none;\n}\n\n.emr-mz-dashboard .btn.emr-aptform__secondary:hover,\n.emr-aptform__secondary:hover {\n  border-color: var(--emr-aptform-primary);\n  background: #e3f2fd !important;\n}\n\n.emr-aptform__icon {\n  width: 14px;\n  height: 14px;\n}\n\n.emr-aptform__req {\n  color: #d32f2f;\n}\n\n.emr-aptform__section {\n  margin: 0 0 8px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  background: var(--emr-aptform-surface);\n  border: 1px solid var(--emr-aptform-border);\n  box-shadow: none;\n  padding: 8px 12px 10px;\n}\n\n.emr-aptform__section-title {\n  margin: 0 0 6px;\n  font-size: 11px !important;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--emr-aptform-muted);\n}\n\n.emr-aptform__row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  column-gap: var(--emr-aptform-label-gap);\n  row-gap: 2px;\n  align-items: center;\n  min-width: 0;\n  padding: 3px 0;\n}\n\n.emr-aptform__label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--emr-aptform-text);\n  line-height: 1.3;\n  padding-top: 0;\n  min-width: 0;\n}\n\n.emr-mz-dashboard .emr-aptform label.emr-aptform__label,\n.emr-aptform label.emr-aptform__label {\n  display: block;\n  margin: 0;\n  left: auto;\n  transform: none;\n  height: auto;\n  position: static;\n}\n\n.emr-aptform__control {\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n.emr-aptform__cluster {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n}\n\n@media only screen and (min-width: 601px) {\n  .emr-aptform__row {\n    grid-template-columns: var(--emr-aptform-label) minmax(0, 1fr);\n    align-items: center;\n  }\n\n  .emr-aptform__row--start {\n    align-items: start;\n  }\n\n  .emr-aptform__row--start .emr-aptform__label {\n    padding-top: 8px;\n  }\n\n  .emr-mz-dashboard .emr-aptform label.emr-aptform__label,\n  .emr-aptform label.emr-aptform__label,\n  .emr-aptform__label {\n    width: 100% !important;\n    max-width: none;\n    box-sizing: border-box;\n  }\n\n  .emr-aptform__indent {\n    margin-left: calc(var(--emr-aptform-label) + var(--emr-aptform-label-gap));\n    padding-left: 0;\n  }\n}\n\n@media only screen and (min-width: 900px) {\n  .emr-aptform__cluster--split,\n  .emr-aptform__cluster--when {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    column-gap: 24px;\n    align-items: start;\n  }\n\n  .emr-aptform__cluster--split .emr-aptform__row,\n  .emr-aptform__cluster--when .emr-aptform__row {\n    width: 100%;\n    min-width: 0;\n  }\n}\n\n.emr-mz-dashboard .emr-aptform input.emr-aptform__input,\n.emr-aptform input.emr-aptform__input,\n.emr-mz-dashboard .emr-aptform textarea.emr-aptform__input,\n.emr-aptform textarea.emr-aptform__input {\n  height: 36px !important;\n  min-height: 36px !important;\n  width: 100% !important;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0 !important;\n  box-sizing: border-box !important;\n  padding: 0 10px !important;\n  border: 1px solid var(--emr-aptform-border) !important;\n  border-radius: 0 !important;\n  background: var(--emr-aptform-surface) !important;\n  box-shadow: none !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  color: var(--emr-aptform-text) !important;\n  line-height: 34px !important;\n}\n\n.emr-mz-dashboard .emr-aptform textarea.emr-aptform__input,\n.emr-aptform textarea.emr-aptform__input {\n  height: auto !important;\n  min-height: 72px !important;\n  padding: 8px 10px !important;\n  line-height: 1.4 !important;\n  resize: vertical;\n}\n\n.emr-mz-dashboard .emr-aptform input.emr-aptform__input:focus,\n.emr-mz-dashboard .emr-aptform textarea.emr-aptform__input:focus,\n.emr-aptform input.emr-aptform__input:focus,\n.emr-aptform textarea.emr-aptform__input:focus {\n  border: 1px solid var(--emr-aptform-primary) !important;\n  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18) !important;\n  outline: none;\n}\n\n.emr-mz-dashboard .emr-aptform input[type=\"date\"],\n.emr-aptform input[type=\"date\"] {\n  min-width: 0 !important;\n  max-width: 100%;\n}\n\n.emr-aptform__search {\n  position: relative;\n  min-width: 0;\n}\n\n.emr-aptform__search-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  width: 14px;\n  height: 14px;\n  transform: translateY(-50%);\n  color: var(--emr-aptform-muted);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.emr-mz-dashboard .emr-aptform input.emr-aptform__search-input,\n.emr-aptform input.emr-aptform__search-input {\n  padding-left: 32px !important;\n}\n\n.emr-aptform__results {\n  position: absolute;\n  z-index: 30;\n  top: calc(100% + 2px);\n  left: 0;\n  right: 0;\n  max-height: 240px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid var(--emr-aptform-border);\n  box-shadow: none;\n}\n\n.emr-aptform__result {\n  display: flex;\n  width: 100%;\n  min-width: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 6px 10px;\n  text-align: left;\n  background: #fff;\n  border: 0;\n  cursor: pointer;\n}\n\n.emr-aptform__result:hover,\n.emr-aptform__result:focus {\n  background: #e3f2fd;\n}\n\n.emr-aptform__result-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--emr-aptform-text);\n}\n\n.emr-aptform__result-meta,\n.emr-aptform__results-empty,\n.emr-aptform__hint {\n  font-size: 12px;\n  color: var(--emr-aptform-muted);\n}\n\n.emr-aptform__results-empty {\n  padding: 8px 10px;\n}\n\n.emr-aptform__hint {\n  padding: 2px 0 4px;\n}\n\n.emr-aptform__patient {\n  display: flex;\n  min-width: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 12px;\n  padding: 8px 10px;\n  background: #fafbfc;\n  border: 1px solid var(--emr-aptform-border);\n}\n\n.emr-aptform__avatar {\n  display: flex;\n  height: 32px;\n  width: 32px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  background: #e3f2fd;\n  color: var(--emr-aptform-primary);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.emr-aptform__patient-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--emr-aptform-text);\n}\n\n.emr-aptform__mrn {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 7px;\n  background: #0b1f33;\n  color: #90caf9;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.emr-aptform__patient-meta {\n  font-size: 12px;\n  color: var(--emr-aptform-muted);\n}\n\n.emr-aptform a.emr-aptform__chart-link,\n.emr-aptform__chart-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--emr-aptform-primary) !important;\n  text-decoration: none;\n}\n\n.emr-aptform__chart-link:hover {\n  text-decoration: underline;\n}\n\n.emr-aptform__noshow {\n  font-size: 12px;\n  font-weight: 600;\n  color: #ef6c00;\n}\n\n.emr-aptform__date,\n.emr-aptform__time,\n.emr-aptform__select--sm {\n  width: 100%;\n  max-width: 100%;\n}\n\n.emr-aptform__end {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--emr-aptform-text);\n}\n\n.emr-mz-dashboard .emr-aptform__select,\n.emr-aptform__select {\n  height: 36px !important;\n  min-height: 36px !important;\n  width: 100% !important;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box !important;\n  border: 1px solid var(--emr-aptform-border) !important;\n  border-radius: 0 !important;\n  background: var(--emr-aptform-surface) !important;\n  box-shadow: none !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n}\n\n.emr-mz-dashboard .emr-aptform__select:focus,\n.emr-aptform__select:focus {\n  border: 1px solid var(--emr-aptform-primary) !important;\n  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18) !important;\n  outline: none;\n}\n\n.emr-aptform-select {\n  border-radius: 0 !important;\n  border: 1px solid var(--emr-aptform-border, #e0e0e0) !important;\n  background: #fff !important;\n  box-shadow: none !important;\n  z-index: 200;\n}\n\n.emr-aptform__radios {\n  display: flex !important;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 12px;\n}\n\n.emr-aptform__radio {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.emr-aptform [role=\"radio\"] {\n  width: 14px !important;\n  height: 14px !important;\n  min-width: 14px;\n  border: 1px solid #90a4ae !important;\n  background: #fff !important;\n  box-shadow: none !important;\n  border-radius: 50% !important;\n}\n\n.emr-aptform [role=\"radio\"][data-state=\"checked\"] {\n  border-color: var(--emr-aptform-primary) !important;\n  color: var(--emr-aptform-primary) !important;\n}\n\n.emr-aptform [role=\"radio\"] svg {\n  width: 8px !important;\n  height: 8px !important;\n  fill: var(--emr-aptform-primary) !important;\n  border-radius: 50% !important;\n}\n\n.emr-aptform__radio-label {\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 400 !important;\n  color: var(--emr-aptform-text);\n  line-height: 1.2;\n}\n\n.emr-aptform__referring {\n  display: flex;\n  min-width: 0;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 6px 8px;\n  background: #fafbfc;\n  border: 1px solid var(--emr-aptform-border);\n}\n\n.emr-aptform__referring-name {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--emr-aptform-text);\n}\n\n.emr-aptform__referring-org {\n  margin: 1px 0 0;\n  font-size: 12px;\n  color: var(--emr-aptform-muted);\n}\n\n.emr-aptform__clear {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--emr-aptform-muted);\n  cursor: pointer;\n}\n\n.emr-aptform__clear:hover {\n  color: var(--emr-aptform-primary-dark);\n}\n\n.emr-aptform__count {\n  margin-top: 2px;\n  text-align: right;\n  font-size: 11px;\n  color: var(--emr-aptform-muted);\n}\n\n.emr-aptform__note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 8px 10px;\n  margin: 4px 0;\n  background: #e3f2fd;\n  border: 1px solid #bbdefb;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #0d47a1;\n}\n\n.emr-aptform__note-icon {\n  width: 14px;\n  height: 14px;\n  margin-top: 1px;\n  flex-shrink: 0;\n}\n\n.emr-aptform__preview-body {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.emr-aptform__preview-meta {\n  display: flex;\n  min-width: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 12px;\n  font-size: 13px;\n  color: var(--emr-aptform-text);\n}\n\n.emr-aptform__preview-date {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--emr-aptform-muted);\n}\n\n.emr-aptform__preview-strong {\n  font-weight: 600;\n}\n\n.emr-aptform__preview-muted {\n  color: var(--emr-aptform-muted);\n}\n\n.emr-aptform__chip {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  background: #e8f5e9;\n  color: #2e7d32;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.emr-aptform__preview-actions {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.emr-aptform__status-msg {\n  padding: 28px 16px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--emr-aptform-muted);\n}\n\n@media only screen and (min-width: 1024px) {\n  .emr-aptform__preview-body {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n@media only screen and (max-width: 899px) {\n  .emr-aptform__pagehead {\n    flex-wrap: wrap;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .emr-aptform__pagehead {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .emr-mz-dashboard .emr-aptform__title,\n  .emr-aptform__title {\n    font-size: 18px !important;\n  }\n\n  .emr-aptform__head-actions,\n  .emr-aptform__preview-actions {\n    width: 100%;\n  }\n\n  .emr-mz-dashboard .btn.emr-aptform__cancel,\n  .emr-mz-dashboard .btn.emr-aptform__save,\n  .emr-mz-dashboard .btn.emr-aptform__secondary,\n  .emr-aptform__cancel,\n  .emr-aptform__save,\n  .emr-aptform__secondary {\n    flex: 1 1 auto;\n    width: auto;\n    min-width: 0;\n  }\n\n  .emr-aptform__date,\n  .emr-aptform__time,\n  .emr-aptform__select--sm {\n    max-width: 100%;\n  }\n\n  .emr-aptform__section {\n    padding: 8px 10px;\n  }\n}\n\n/* ------------------------------------------------------------------ */\n/* Access-style modular two-column layout.                            */\n/* New Appointment uses --new. Edit Appointment uses --edit only.     */\n/* ------------------------------------------------------------------ */\n\n.emr-aptform--new,\n.emr-aptform--edit {\n  --emr-aptform-label: 128px;\n  --emr-aptform-label-gap: 10px;\n}\n\n.emr-aptform--new .emr-aptform__pagehead,\n.emr-aptform--edit .emr-aptform__pagehead {\n  margin-bottom: 8px;\n}\n\n.emr-aptform--new .emr-aptform__modules,\n.emr-aptform--edit .emr-aptform__modules {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.emr-aptform--new .emr-aptform__section,\n.emr-aptform--edit .emr-aptform__section {\n  margin: 0;\n  min-width: 0;\n  height: auto;\n}\n\n.emr-aptform--new .emr-aptform__module,\n.emr-aptform--edit .emr-aptform__module {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n@media only screen and (min-width: 1024px) {\n  .emr-aptform--new .emr-aptform__modules,\n  .emr-aptform--edit .emr-aptform__modules {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    gap: 8px;\n    align-items: stretch;\n  }\n\n  .emr-aptform--new .emr-aptform__module--wide,\n  .emr-aptform--edit .emr-aptform__module--wide {\n    grid-column: 1 / -1;\n  }\n\n  .emr-aptform--new .emr-aptform__module,\n  .emr-aptform--edit .emr-aptform__module {\n    height: 100%;\n  }\n\n  /* Half-width modules: stack Date/Time pairs so long values stay readable. */\n  .emr-aptform--new .emr-aptform__cluster--when,\n  .emr-aptform--edit .emr-aptform__cluster--when {\n    display: flex;\n    flex-direction: column;\n    column-gap: 0;\n  }\n\n  /* Edit only: stack Where/Who so long location names stay readable. */\n  .emr-aptform--edit .emr-aptform__cluster--split {\n    display: flex;\n    flex-direction: column;\n    column-gap: 0;\n  }\n\n  .emr-aptform--new textarea.emr-aptform__input,\n  .emr-aptform--edit textarea.emr-aptform__input {\n    min-height: 56px !important;\n  }\n\n  .emr-aptform--new .emr-aptform__note,\n  .emr-aptform--edit .emr-aptform__note {\n    padding: 6px 8px;\n    margin: 2px 0 4px;\n  }\n}\n\n/* Half-width modules: stack Where/Who pairs below 1440 so labels stay aligned. */\n@media only screen and (min-width: 1024px) and (max-width: 1439px) {\n  .emr-aptform--new .emr-aptform__cluster--split,\n  .emr-aptform--edit .emr-aptform__cluster--split {\n    display: flex;\n    flex-direction: column;\n    column-gap: 0;\n  }\n}\n\n/* Wide screens: use remaining horizontal space inside Visit and When. */\n@media only screen and (min-width: 1440px) {\n  .emr-aptform--new .emr-aptform__module--visit,\n  .emr-aptform--new .emr-aptform__module--when,\n  .emr-aptform--edit .emr-aptform__module--visit,\n  .emr-aptform--edit .emr-aptform__module--when {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    column-gap: 16px;\n    align-items: start;\n  }\n\n  .emr-aptform--new .emr-aptform__module--visit .emr-aptform__section-title,\n  .emr-aptform--new .emr-aptform__module--visit > .emr-aptform__row:nth-of-type(1),\n  .emr-aptform--new .emr-aptform__module--visit > .emr-aptform__row:nth-of-type(4),\n  .emr-aptform--new .emr-aptform__module--when .emr-aptform__section-title,\n  .emr-aptform--new .emr-aptform__module--when > .emr-aptform__cluster,\n  .emr-aptform--edit .emr-aptform__module--visit .emr-aptform__section-title,\n  .emr-aptform--edit .emr-aptform__module--visit > .emr-aptform__row:nth-of-type(1),\n  .emr-aptform--edit .emr-aptform__module--visit > .emr-aptform__row:nth-of-type(4),\n  .emr-aptform--edit .emr-aptform__module--when .emr-aptform__section-title,\n  .emr-aptform--edit .emr-aptform__module--when > .emr-aptform__cluster {\n    grid-column: 1 / -1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
